<div class="comparison-card card p-3" [ngStyle]="{ 'background': color.bg, 'border-color': color.border }">
  <div class="d-flex flex-column">
    <span class="sec-title"> Test Case ID </span>
    <strong> {{ data.id }} </strong>
  </div>

  <div class="d-flex flex-column my-3">
    <span class="sec-title"> Test Steps </span>
    <ol>
      <li *ngFor="let item of data.steps">{{ item }}</li>
    </ol>
  </div>

  <div class="d-flex flex-column">
    <span class="sec-title"> Expected Results </span>
    <ol>
      <li *ngFor="let item of data.results">{{ item }}</li>
    </ol>
  </div>
</div>
